(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carousel-slider')) {
    customElements.define(
      'carousel-slider',
      class CarouselSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          if (!this.track) return;

          this.controls = this.querySelector('[data-carousel-controls]');
          this.previous = this.querySelector('[data-carousel-previous]');
          this.next = this.querySelector('[data-carousel-next]');
          this.update = this.update.bind(this);

          this.previous?.addEventListener('click', () => this.step(-1));
          this.next?.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', this.update, { passive: true });

          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        // A step lands on the neighbouring slide's start rather than moving a
        // fixed distance, because slides may differ in width (the journal's
        // staggered cards) and a short step would snap back where it began.
        step(direction) {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const trackRect = this.track.getBoundingClientRect();

          const offsets = Array.from(this.track.children, (slide) => {
            const rect = slide.getBoundingClientRect();
            return rtl ? trackRect.right - rect.right : rect.left - trackRect.left;
          });

          const target = direction > 0 ? offsets.find((offset) => offset > 1) : offsets.findLast((offset) => offset < -1);
          if (target === undefined) return;

          this.track.scrollBy({
            left: target * (rtl ? -1 : 1),
            behavior: reduced ? 'auto' : 'smooth',
          });
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          // scrollLeft counts down from zero in right-to-left writing modes.
          const position = Math.abs(scrollLeft);
          const end = scrollWidth - clientWidth;

          if (this.controls) this.controls.hidden = end <= 1;
          if (this.previous) this.previous.disabled = position <= 1;
          if (this.next) this.next.disabled = position >= end - 1;
        }
      }
    );
  }

  // The theme editor scrolls the page to a selected block, but not a track
  // sideways, so a slide selected off to the right would stay out of view.
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const slide = event.target.closest('[data-carousel-track] > *');
    const track = slide?.parentElement;
    if (!slide || !track) return;

    const offset = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
    track.scrollTo({ left: track.scrollLeft + offset, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gallery-track]');
          this.rail = this.querySelector('[data-gallery-thumbnails]');
          this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
          if (!this.track || this.thumbnails.length === 0) return;

          this.thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => this.show(thumbnail.dataset.mediaId));
          });

          // The slide that fills most of the track is the current one. An
          // observer reports that without listening to every scroll event.
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.markCurrent(entry.target.dataset.mediaId);
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.track.querySelectorAll('[data-media-id]').forEach((slide) => this.observer.observe(slide));

          this.onVariantChange = this.onVariantChange.bind(this);
          document.addEventListener('product:variant-change', this.onVariantChange);

          // A variant's featured media may not be the first slide, so the track
          // opens on it rather than making the visitor look for it.
          const current = this.thumbnails.find((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
          if (current && current !== this.thumbnails[0]) this.show(current.dataset.mediaId, 'instant');
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          document.removeEventListener('product:variant-change', this.onVariantChange);
        }

        onVariantChange(event) {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;

          const mediaId = event.detail.variant?.featured_media;
          if (mediaId) this.show(String(mediaId));
        }

        show(mediaId, behavior) {
          const slide = this.track.querySelector(`[data-media-id="${mediaId}"]`);
          if (!slide) return;

          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const offset = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;

          // 'auto' would defer to the track's CSS scroll-behavior, which is smooth.
          this.track.scrollBy({ left: offset, behavior: behavior || (reduced ? 'instant' : 'smooth') });
          this.markCurrent(mediaId);
        }

        markCurrent(mediaId) {
          this.thumbnails.forEach((thumbnail) => {
            if (thumbnail.dataset.mediaId !== mediaId) {
              thumbnail.removeAttribute('aria-current');
              return;
            }

            thumbnail.setAttribute('aria-current', 'true');
            this.revealThumbnail(thumbnail);
          });
        }

        // Scrolls only the rail. scrollIntoView would also scroll the page.
        revealThumbnail(thumbnail) {
          if (!this.rail) return;

          const rail = this.rail.getBoundingClientRect();
          const rect = thumbnail.getBoundingClientRect();

          if (rect.top < rail.top || rect.bottom > rail.bottom) {
            this.rail.scrollBy({ top: rect.top - rail.top, behavior: 'smooth' });
          }
          if (rect.left < rail.left || rect.right > rail.right) {
            this.rail.scrollBy({ left: rect.left - rail.left, behavior: 'smooth' });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
